import { styled } from "@mui/material";

export const ArticleCollectionPanelsContainer = styled("div")(() => ({
  gridColumn: "3 span",
  display: "block",
}));
